import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getOrgs, createOrg } from 'Data/api';
import useGlobalState from 'Hooks/useGlobalState';
import CircularLoader from 'Components/Loaders/CircularLoader';
import { Card, CardHeader, CardContent, Container, Grid, TextField, Button } from '@mui/material'; // Container, Grid, Typography, 
import mainStyles from 'Styles/mainStyles';

const initOrgTree = (data) => {
	data.sort((a, b) => a.name.localeCompare(b.name));
	data.forEach(org => {
		org.suborgs = data.filter(suborg => {
			return suborg.org.uuid === org.uuid
		});
	});
	return data;
}

const AdminOrganisationAdd = () => {
	const { uuid } = useParams();
	const navigate = useNavigate();

	const [globalState, dispatch] = useGlobalState();
	const { orgs } = globalState;
	// const [orgs, setOrgs] = useState([]);
	const [myOrg, setMyOrg] = useState(null);
	const [newOrg, setNewOrg] = useState({ name: '', uuid: '', org: null });
	const [createTitle, setCreateTitle] = useState('Opret organisation');

	const classes = mainStyles();

	const [errorMsg, setErrorMsg] = useState('');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		dispatch({ adminTitle: 'Rediger organisation' });
		const fetchData = async () => {
			let orgs = await getOrgs().then(data => {
				// console.log('Admin - useEffect - orgs', data);
			return initOrgTree(data);
			});
			console.log('Admin - useEffect - orgs', orgs);
			dispatch({ orgs: orgs });

			console.log('Admin - useEffect', orgs);
			let selectedOrg = orgs.filter(org => {
				return org.uuid === uuid
			});
			setMyOrg(selectedOrg[0]);

			setLoading(false);
		}
		fetchData();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const fetchData = async () => {
			setLoading(true);
			console.log('AdminOrganisation - useEffect - uuid', uuid);
			let selectedOrg = orgs.filter(org => {
				return org.uuid === uuid
			});
			setMyOrg(selectedOrg[0]);
			// setViewList(selectedOrg[0].suborgs);
			setCreateTitle('Opret organisation under ' + selectedOrg[0].name);
			newOrg.org = selectedOrg[0];
			
		}
		fetchData();
		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [uuid]);

	const handleConfirm = async () => {
		setLoading(true);
		setErrorMsg('');
		console.log('handleConfirm', newOrg);
		if (newOrg && newOrg.name) {
			let updatedOrg = { ...newOrg };
			updatedOrg.name = newOrg.name;
			// Save the updated organisation
			// await updateOrganisation(updatedOrg);
			// dispatch({ myOrg: updatedOrg });
			await createOrg(updatedOrg);
			// Update the global state with the updated organisation
			// dispatch({ myOrg: updatedOrg });
			// Navigate to the organisation page
			alert('Organisationen er gemt');
			navigate('/admin/organisation/' + myOrg.uuid);
		} else {
			setErrorMsg('Organisationen skal have et navn');
		}
		setLoading(false);
	}

	return (!loading ?
		<Container maxWidth="lg" style={{ padding: '20px', marginBottom: '100px' }}>
			<Card>
				<CardHeader title={createTitle}
					action={
						<>
							{/* <AddIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/add")} style={{ cursor: 'pointer', marginRight: '10px' }} />
							<EditIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/edit")} style={{ cursor: 'pointer', marginRight: '10px' }} /> */}
							{/* <DeleteIcon onClick={() => navigate("/admin/organisation/" + myOrg.uuid + "/delete")} style={{ cursor: 'pointer' }} /> */}
						</>
					}
				/>
				<CardContent>
					{/* <Grid container spacing={2} style={{ marginTop: '0px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							{myOrg && myOrg.name}
						</Grid>
					</Grid> */}
					{errorMsg ? <div className={classes.errorMsg}>{errorMsg}</div> : ""}
					<Grid container spacing={2} style={{ marginTop: '20px' }}>
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<TextField
								style={{ width: '100%' }}
								autoFocus
								id="orgname"
								label="Organisationsnavn"
								variant="outlined"
								onChange={(event) => {
										setNewOrg({ ...newOrg, name: event.target.value });
									}
								}
							/>
						</Grid>
						{/* <Grid item xs={12} sm={12} md={12} lg={12}>
							<Autocomplete
								disablePortal
								id="combo-box-demo"
								options={orgs}
								getOptionLabel={(option) => option.name + '(' + option.uuid + ')'}
								renderInput={(params) => <TextField {...params} label="Vælg overordnet organisation" />}
								value={myOrg.org}
								onChange={(event, value) => {
									if (value) {
										console.log('Selected organisation:', value);
										// Here you can handle the selected organisation, e.g., update the myOrg
										setMyOrg(value); // Update the myOrg
										dispatch({ myOrg: value }); // Update the global state
									}
								}}
								style={{ width: '100%' }}
							/>
							</Grid> */}
						<Grid item xs={12} sm={12} md={12} lg={12}>
							<Button onClick={handleConfirm} variant="contained" className={classes.greenButton}>Gem</Button>
						</Grid>
					</Grid>
				</CardContent>
			</Card>
		</Container>
		:
		<CircularLoader />
	);
};

export default AdminOrganisationAdd;